import { Button, Card, Result } from 'antd';
import React from 'react';
import ResponsiveContainer from './ResponsiveContainer';

const SolicitudRealizada = () => {
  const styles = {
    aceptoContainer: {
      textAlign: 'justify',
      paddingTop: 40,
      paddingBottom: 40
    },
    acepto: {
      fontSize: 17,
      fontWeight: 'bold',
      textalign: 'justify',
      display: 'flex',
      alignItems: 'center'
    },
    list: {
      textAlign: 'left',
      maxWidth: 500,
      margin: 'auto',
      marginTop: 40
    },
    icon: { fontSize: 20 }
  };
  return (
    <div style={styles.content}>
      <ResponsiveContainer>
        <Card>
          <Result
            status="success"
            title="¡La solicitud ya ha sido realizada!"
            subTitle=""
            extra={[
              <Button
                type="primary"
                key="console"
                onClick={() => {
                  window.location.href = `/`;
                }}
              >
                Ir al inicio
              </Button>
            ]}
          />
        </Card>
      </ResponsiveContainer>
    </div>
  );
};

export default SolicitudRealizada;
